import { AudioBusBox, AudioUnitBox } from "@opendaw/studio-boxes";
import { IndexedBox } from "@opendaw/lib-box";
import { AudioSendRouting } from "@opendaw/studio-enums";
import { asInstanceOf, panic } from "@opendaw/lib-std";
import { Facade } from "./Common";
import { Guard } from "./Guard";
import { AudioUnitImpls } from "./AudioUnits";
export class SendImpl extends Facade {
    static wrap(context, box) {
        return context.facade(box, () => new SendImpl(context, box));
    }
    constructor(context, box) {
        super(context, box);
        this.bind({ amount: box.sendGain, pan: box.sendPan });
    }
    get audioUnit() {
        const field = this.box.audioUnit.targetVertex.unwrap("send has no audio unit");
        return AudioUnitImpls.wrap(this.context, asInstanceOf(field.box, AudioUnitBox));
    }
    get target() {
        const busBox = asInstanceOf(this.box.targetBus.targetVertex.unwrap("send has no target").box, AudioBusBox);
        const unitField = busBox.output.targetVertex.unwrap("bus has no audio unit");
        return AudioUnitImpls.wrap(this.context, asInstanceOf(unitField.box, AudioUnitBox));
    }
    get mode() { return this.box.routing.getValue() === AudioSendRouting.Pre ? "pre" : "post"; }
    set mode(value) {
        const validated = Guard.oneOf(value, ["pre", "post"], "mode");
        this.context.edit(() => this.box.routing.setValue(validated === "pre" ? AudioSendRouting.Pre : AudioSendRouting.Post));
    }
    get index() { return this.box.index.getValue(); }
    remove() {
        this.context.edit(() => {
            const field = this.box.audioUnit.targetVertex.unwrap("send has no audio unit");
            const index = this.index;
            IndexedBox.removeOrder(field, index);
            this.box.delete();
        });
    }
}
export var Sends;
(function (Sends) {
    Sends.validateTarget = (target) => {
        if (!(target instanceof Facade) || !(target.box instanceof AudioUnitBox)) {
            return panic(new TypeError("Send target must be an auxiliary or group unit"));
        }
        const unitBox = target.box;
        if (unitBox.type.getValue() !== "aux" && unitBox.type.getValue() !== "bus") {
            return panic(new TypeError(`Send target must be an auxiliary or group unit, got ${unitBox.type.getValue()}`));
        }
        return asInstanceOf(unitBox.input.pointerHub.incoming().map(({ box }) => box).find(box => box instanceof AudioBusBox), AudioBusBox);
    };
})(Sends || (Sends = {}));
